<template>
  <v-container class="top-spacer">
    <div class="component-title">Jogos</div>
    <v-row>
      <v-col cols="12">
        <MatchesTable></MatchesTable>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>

</style>

<script>
import MatchesTable from "@/components/backoffice/MatchesTable.vue";

export default {
  name: "BackofficeMatches",
  components: {
    MatchesTable
  },
  data: () => ({
    tab: null,
  })
};
</script>
